import {
    useMutation,
    UseMutationOptions,
    useQuery,
    UseQueryOptions,
  } from "@tanstack/react-query";
  
  import { CoreApi } from "../helpers/Http";
  
  /**
   *  Get DataSources connections cred-config
   *
   * @param payload
   * @param options
   * @returns
   */
  
  export const useGetDataSourcesConnectionsCred = (options?: UseQueryOptions) => {
    const queryFn = async () => await CoreApi.get(`/datasources/connections`);
  
    return useQuery({
      queryKey: ["connections-cred"],
      queryFn,
    });
  };

  /**
 * Delete DataSourceConnection
 *
 * @param payload
 * @param options
 * @returns
 */

export const useDeleteDataSourceConnection = (options?: UseMutationOptions) => {
    const mutationFn = async (id: any) =>
      await CoreApi.delete(`datasources/connections/${id}`);
    return useMutation({ mutationFn });
};

 /**
 * Update Data Sources Connection
 *
 * @param payload
 * @param options
 * @returns
 */

 export const useUpdateDataSourceConnection = (
	options?: UseMutationOptions
) => {
	const mutationFn = async ({ id, body }: any) =>
		await CoreApi.post(`datasources/${id}/connections`, body);

	return useMutation({ mutationFn });
};

  